var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeater = function SvgHeater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.993 11.648V7.331m0 0 1.15.998m-1.15-.998-1.148.998M11.69 7.107v9.29m0 0a1.083 1.083 0 1 0 0 2.166 1.083 1.083 0 0 0 0-2.167m-4.38-5.123H5.858M7.31 9.096H5.858M7.31 6.92H5.858m3.655 8.136V5.437a2.178 2.178 0 0 1 4.355 0v9.618a3.25 3.25 0 0 1 1.082 2.504 3.27 3.27 0 0 1-3.13 3.179 3.264 3.264 0 0 1-3.39-3.258c0-.962.418-1.828 1.083-2.425"
  })));
};
export default SvgHeater;